(function () {
  var lastFired = 0;

  function pushAppointmentSubmit(identifier) {
    var now = Date.now();
    // Some form apps trigger both a real submit event AND a submit-like button
    // click for the same action — this collapses those into a single event.
    if (now - lastFired < 800) return;
    lastFired = now;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'appointment_form_submit',
      form_id: identifier || '',
      page_path: window.location.pathname,
    });
  }

  function findInModalPath(event, matchEl) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    var insideAppointmentModal = false;
    var matched = null;

    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (el && el.id === 'que-modal') insideAppointmentModal = true;
      if (el && matchEl(el) && !matched) matched = el;
      if (el === document || el === window) break;
    }

    return insideAppointmentModal ? matched : null;
  }

  // Covers form apps that use a real native form submission.
  document.addEventListener(
    'submit',
    function (event) {
      var form = findInModalPath(event, function (el) {
        return el.tagName === 'FORM';
      });
      if (!form) return;
      pushAppointmentSubmit(form.id || form.className);
    },
    true
  );

  // Covers form apps (e.g. SureCust) that use a plain button + AJAX instead of
  // a real form submission, so no 'submit' event ever fires.
  document.addEventListener(
    'click',
    function (event) {
      var button = findInModalPath(event, function (el) {
        if (el.tagName !== 'BUTTON' && el.tagName !== 'INPUT') return false;
        var label = (el.className || '') + ' ' + (el.textContent || '') + ' ' + (el.value || '');
        return /submit/i.test(label);
      });
      if (!button) return;
      pushAppointmentSubmit(button.className || button.id);
    },
    true
  );
})();
